/** Gnothi brand tokens — the one source for web (`web/src/ui/Setup/Mui.tsx`), mobile (`mobile/theme`), videos (`videos/src/lib/theme.ts`) and the logo/store-asset pipeline (`videos/brand/`). Dependency-free so any bundler can import it. The iOS widget (`mobile/targets/widget/expo-target.config.js`) is CommonJS read at prebuild and keeps its own copy of `accentRamp`/`accentLight` (and navy for the on-accent mic). */
export const BRAND = {
  /** Primary accent. */
  accent: '#00A8E8',
  accentRamp: '#0077c2',
  accentLight: '#38bdf8',
  /** Dark chrome surface and icon background. */
  navy: '#0A1128',
  navyRamp: '#1a295c',
  /** The logo's halo and hilt. */
  gold: '#b8860b',
  paper: '#ffffff',
  surface: '#f8fafc',
} as const

export const BRAND_FONTS = {heading: 'Outfit', body: 'Inter'} as const
